<!--
 * @Description: 订单详情组件
 * @Author: gaohc, wanq
 * @Date: 2022-03-16 16:43:52
-->
<template>
  <div class="body">
    <el-dialog class="order-details-dialog" width="83%" title="订单详情" :visible.sync="visible"
      :close-on-click-modal="false" @open="initData" :before-close="handleCancel" center>
      <div class="dialog-body">
        <div class="order-msg-main">
          <el-descriptions title="" :column="20" direction="vertical">
            <el-descriptions-item :span="4" label="订单号">
              {{ order.no }}
            </el-descriptions-item>
            <el-descriptions-item :span="4" label="下单人">
              {{ orderData.createOrderUserInfo || '- -' }}
            </el-descriptions-item>
            <el-descriptions-item :span="4" label="下单时间">
              {{ order.genTime }}
            </el-descriptions-item>
            <el-descriptions-item :span="3" label="支付方式">
              {{ orderData.payTypeTxt }}
              <span v-if="order.paymentModeText">{{orderData.payTypeTxt ? ('- ' + order.paymentModeText) :  order.paymentModeText}}</span>
            </el-descriptions-item>
            <el-descriptions-item :span="3" label="订单状态">
              {{ order.statusText }}
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="订单来源">
              {{ orderData.orderSource }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="service-details-main">
          <el-descriptions title="用户信息">
            <template v-if="!order.isDelegateOrder">
              <el-descriptions-item label="购买人">
                <span>{{ orderData.userName }} {{ orderData.userMobile }}</span>
              </el-descriptions-item>
              <el-descriptions-item label="服务对象">
                <span>
                  {{ orderData.servedPersonName ? orderData.servedPersonName : "- -" }}
                  {{ orderData.servedPersonGender }}
                  {{ orderData.servedPersonAge ? orderData.servedPersonAge + "岁" : "" }}
                </span>
              </el-descriptions-item>
            </template>
            <template v-else>
              <el-descriptions-item label="被服务人/患者姓名">
                <span>{{ orderData.servedPersonName  || '- -'}}</span>
              </el-descriptions-item>
              <el-descriptions-item label="联系电话">
                <span>
                  {{ orderData.servedPersonMobile || "- -" }}
                </span>
              </el-descriptions-item>
            </template>
          </el-descriptions>
        </div>

        <div class="service-details-main">
          <el-descriptions title="服务套餐信息">
            <el-descriptions-item label="住院医院">
              {{ orderData.hospitalTxt }}
            </el-descriptions-item>
            <el-descriptions-item label="住院科室">
              {{ orderData.dept1Name }} {{ orderData.dept2Name }}
            </el-descriptions-item>
            <el-descriptions-item label="床位号">
              {{ orderData.inpatientWardName }} {{ order.inpatientBedNo }}
            </el-descriptions-item>
            <el-descriptions-item label="服务机构">
              {{ orderData.institutionName }}
            </el-descriptions-item>
            <el-descriptions-item label="服务时间">
              {{ changeDate(order.startTime) }} 至 {{ changeDate(order.endTime) }}
              共{{order.durationText}}
            </el-descriptions-item>
            <el-descriptions-item label="期望服务人">
              {{ order.expectedAttendant ? order.expectedAttendant : "- -" }}
              {{ orderData.expectedAttendantGender }}
              {{ orderData.expectedAttendantAge ? orderData.expectedAttendantAge + "岁" : "" }}
            </el-descriptions-item>
            <el-descriptions-item v-if="order.paymentMode == 1 && (orderData.evaluatorName || orderData.havePayDetail)" label="评估人员">
              <span>{{orderData.evaluatorName ? orderData.evaluatorName : "- -" }}</span>
              <span @click="handleClickCollectdetails" v-if="orderData.havePayDetail"
                style="color: #3e7ef6; margin-left: 45px; cursor: pointer">
                评估收款详情
              </span>
            </el-descriptions-item>
            <el-descriptions-item label="派单人员">
              <span>{{ orderData.distributorName ? orderData.distributorName : "- -" }}</span>
            </el-descriptions-item>
            <el-descriptions-item v-if="order.status == 93 || order.status == 2" label="取消人">
              <span>
				        {{ orderData.cancelOrderNameOrMobile ? orderData.cancelOrderNameOrMobile : "- -" }}
              </span>
              <span v-if="order.cancelledType">
                （{{ order.cancelledType == 1 ? "购买人" : "派单人" }}）
              </span>
            </el-descriptions-item>
          </el-descriptions>

          <el-descriptions title="" class="service-main" direction="vertical" :column="9" border>
            <el-descriptions-item label="服务套餐" :span="2">
              {{ orderData.hservicePkgName }}
            </el-descriptions-item>
            <el-descriptions-item label="服务单价(元)">
              <span class="text-bold-600">￥{{ order.hsvcPkgUnitPriceYuan }}</span>
              <div style="color: #333; font-size: 12px">
                {{ orderData.serviceDuration ? orderData.serviceDuration + "小时" : "" }}
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="护理员价格(元)">
              <span class="text-bold-600"> ￥{{ order.attendantLevelUnitPriceYuan }} </span>
              <div style="color: #333; font-size: 12px">
                {{ order.attendantLevelText }}
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="总金额">
              <span class="text-bold-600"> ￥{{ order.hsvcAmountYuan }} </span>
            </el-descriptions-item>
            <el-descriptions-item label="议价差额" v-if="order.paymentMode == 1">
              <span class="text-bold-600">￥{{ order.differenceAmountYuan }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="应付款">
              <span class="text-bold-600">￥{{ order.payableAmountYuan }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="实付款">
              <span style="color: #ff403f" class="text-bold-600">￥{{ order.payAmountYuan }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="订单状态">
              <span class="text-bold-600">{{ order.statusText }}</span>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div class="order-duty-rule-main" v-if="orderData.servedPersonDutyList && orderData.servedPersonDutyList.length">
          <div class="header-title">服务人员</div>
          <el-table border :data="orderData.servedPersonDutyList" :header-cell-style="{
			      'text-align': 'center', 'background-color': '#EFF5FA'}">
            <el-table-column label="班次" min-width="35%" align="center">
              <template slot-scope="scope">
                <span>{{ formateDate(scope.row.dutyDate) }}</span>
                <span :style="{ color: scope.row.dutyRuleId ? scope.row.color : '#606266'}">
                  {{ scope.row.name ? scope.row.name : "" }}
                  ({{ scope.row.dutyRuleStartTime }}-{{ scope.row.dutyRuleEndTime }})
                </span>
              </template>
            </el-table-column>
            <el-table-column label="服务人员" min-width="35%" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.attendantName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="服务状态" min-width="30%" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.statusText }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="order-duty-rule-main" v-if="orderData.dutyList && orderData.dutyList.length">
          <div class="header-title">订单排班</div>
          <el-table class="order-table" border :data="dataTable" style="width: fit-content"
            :header-cell-style="{'text-align': 'center', 'background-color': '#EFF5FA'}">
            <el-table-column label="排班" width="120" align="center">
              <template slot-scope="scope">
                <div>{{ scope.row.dutyWeek }}</div>
                <span>{{ scope.row.dutyDate }}</span>
              </template>
            </el-table-column>
            <el-table-column v-for="(i, key) in orderData.attendantList" :key="key"
              width="200" align="center">
              <template slot="header">
                <span>{{ i.name }}</span>
              </template>
              <template slot-scope="scope">
                <div v-if="scope.row.dutyList && scope.row.dutyList.length">
                  <div v-for="(dutyItem, idx) in scope.row.dutyList" :key="idx">
                    <div v-if="dutyItem.attendantId == i.id">
                      <span :style="{color: dutyItem.dutyRuleId ? dutyItem.color : '#606266', 'font-weight': 600}">
                        {{ dutyItem.name ? dutyItem.name : "" }}
                        ({{ dutyItem.dutyRuleStartTime }}-{{ dutyItem.dutyRuleEndTime }})
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="payment-list-wrap" v-if="paymentList.length">
          <div class="header-title" style="margin-bottom: 0">支退记录</div>
          <el-row type="flex" v-for="(i, idx) in paymentList" :key="idx" class="row-bg pament-list">
            <el-col :span="16">
              <div class="grid-content bg-purple">
                <div class="payment-msg-wrap">
                  <el-image :src="i.type == 1 ? paySuccessIcon : refundSuccessIcon" alt="">
                  </el-image>
                  <div class="payment-msg">
                    <span>
                      {{ i.payWayText }}
                      {{ i.amountYuan ? "￥" + i.amountYuan : "- -" }}
                    </span>
                  </div>
                </div>
                <div class="payment-reason">
                  <span>
                    {{ i.type == 1 ? "支付原因：" : "退款原因：" }}
                  </span>
                  <span>
                    {{ i.remark ? i.remark : "- -" }}
                  </span>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple-light payment-date">
                <span>
                  {{ i.payTime ? i.payTime : "- -" }}
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="dialog-footer bk-wizard-bottons">
        <el-button @click="handleCancel">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";

export default {
  name: "OrderDetails",
  props: ["visible", "orderId"],

  data() {
    return {
      dataTable: [],
      orderData: {},
      order: {}, //详情中订单实体对象
      paymentList: [],
      paySuccessIcon: require("../../../assets/ordermng/icon-ordermng-payment.png"),
      refundSuccessIcon: require("../../../assets/ordermng/icon-ordermng-refund.png"),
    };
  },

  computed: {
    changeDate() {
      return function (date) {
        if (date) return date.substring(0, 16);
      };
    },

    changeDutyTime() {
      return function (time) {
        if (time) return time.substring(0, 5);
      };
    },

    formateDate() {
      return function (date) {
        if (date) return this.dateUtil.dateFormat(date, "MM-DD", "CN");
      };
    },

    formattedNumber() {
      return function (number) {
        if (number % 1 === 0) {
          return parseInt(number);
        } else {
          return number;
        }
      }
    }
  },

  methods: {
    handleCancel() {
      this.$emit("close-dialog", false);
    },

    handleClickCollectdetails() {
      this.$emit("check-collectdetails");
    },

	// 获取排班数据
    getDutyTabelData(dutyDateList, dutyList) {
      dutyDateList.forEach((item) => {
        let arr = [];
        dutyList.forEach((i) => {
          if (i.dutyDate == item.dutyDate) {
            arr.push(i);
          }
        });
        item.dutyList = arr;
      });
      this.dataTable = dutyDateList;
    },

    initData() {
      let params = {id: this.orderId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_ORDER_DETAILS,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }

        this.orderData = result.data;
        this.order = result.data.order;
        this.paymentList = result.data.paymentList;
        this.getDutyTabelData(result.data.dutyDatyDOList, result.data.dutyList);
      });
    }
  },
};
</script>

<style scoped>
.order-details-dialog /deep/ .el-dialog__header {
  text-align: center;
}

.order-details-dialog .dialog-body {
  padding: 0 30px 50px 30px;
}

.order-msg-main {
  padding: 20px 20px 0 20px;
}

.order-msg-main,
.order-msg-main /deep/ .el-descriptions__body {
  background-color: #f5f6fa;
}

.order-msg-main /deep/ .el-descriptions-item__label {
  color: #7c899a;
  font-size: 15px;
}

.order-msg-main /deep/ .el-descriptions-item__content {
  font-size: 15px;
  font-weight: 600;
  color: #000000;
}

.service-details-main {
  margin-top: 35px;
}

.service-details-main /deep/ .el-descriptions-item__content {
  font-size: 15px;
  color: #000000;
}

.service-details-main /deep/ .el-descriptions-item__label {
  color: #828f9f;
  font-size: 15px;
}

.order-duty-rule-main,
.payment-list-wrap {
  margin-top: 35px;
}

.order-duty-rule-main .header-title,
.payment-list-wrap .header-title {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 20px;
}

.service-main {
  margin-top: 10px;
}

.service-main /deep/ .el-descriptions-item__label {
  text-align: center;
  background-color: rgb(239, 245, 250);
  font-weight: 600;
  color: #92969b;
  font-size: 14px;
}

.service-main /deep/ .el-descriptions-item__content {
  color: #000000;
  font-size: 14px;
  text-align: center;
}

.dialog-footer {
  text-align: center;
}

.el-table /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 7px; /*滚动条宽度*/
  height: 7px; /*滚动条高度*/
}

.pament-list {
  flex-wrap: wrap;
  border-bottom: 1px solid #ebeef5;
  color: #606266;
  font-size: 14px;
  padding: 30px 0;
}

.pament-list .el-image {
  width: 28px;
  height: 29px;
}

.payment-msg-wrap {
  display: flex;
  align-items: center;
}

.payment-msg {
  margin-left: 10px;
  font-weight: 600;
  color: #000000;
  font-size: 15px;
}

.payment-reason {
  padding: 18px 15px 0 38px;
}

.payment-date {
  margin-top: 47px;
}

.text-bold-600 {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/ordermng/components/OrderDetails.vue